import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { NavMenuDivider, NavMenuItem } from 'components/NavMenu';
import { WebAppInstallPromptContext } from '../../webAppInstallPrompt/context';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AddToHomeScreen() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useContext = useContext(WebAppInstallPromptContext),
    capturedPrompt = _useContext.capturedPrompt,
    promptUser = _useContext.promptUser;
  if (!capturedPrompt) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NavMenuDivider, {}), /*#__PURE__*/_jsx(NavMenuItem, {
      id: "a2hs_button",
      onClick: promptUser,
      children: t('actions_add_to_homescreen')
    })]
  });
}
export default AddToHomeScreen;